<template>
  <div>
    <a-carousel autoplay ref="carousel1">
      <img class="img" src="@/assets/banner.png" alt="" />
      <img class="img" src="@/assets/school.png" alt="" />
    </a-carousel>
    <div class="homeContainer">
      <div class="contentWrap">
        <div class="news">
          <div class="news-header">
            <div class="line fl"></div>
            <div class="title">
              <p class="cn">新闻资讯</p>
              <p class="en">News and information</p>
            </div>
            <div class="line fr"></div>
          </div>
          <div class="news-content">
            <div class="img-box fl">
              <img
                v-for="(item, key) in newList"
                :key="key"
                v-show="current == key"
                class="img fl"
                :src="item.newImg"
                alt=""
              />
            </div>

            <ul class="list fl">
              <li
                v-for="(item, key) in newList"
                :key="key"
                @mouseover="
                  showImage(key);
                  stopAutoSwitch();
                "
                @mouseout="startAutoSwitch(item)"
                @click="goNewDetail(item)"
                :class="{ active: current == key }"
              >
                <span class="pie fl"></span>
                <span class="word">{{ item.newName }}</span>
                <span class="time fr">{{ item.addTime }}</span>
              </li>
            </ul>
          </div>
          <div class="more" @click="$router.push('/newHome/news')">
            查看更多 <span class="jia">+</span>
          </div>
        </div>
        <div class="index">
          <div class="header">
            <span class="index-center fl">指数中心</span>
            <span class="more fr" @click="goDataIndex"
              >更多 <img src="@/assets/fr.png"
            /></span>
          </div>
          <div class="title-btn">
            <span
              class="span"
              :class="{ active: currentSlide == 3 }"
              @click="goTo(3)"
              >边疆治理指数</span
            >
            <span
              class="span"
              :class="{ active: currentSlide == 0 }"
              @click="goTo(0)"
              >包容性发展指数</span
            >
            <span
              class="span"
              :class="{ active: currentSlide == 1 }"
              @click="goTo(1)"
              >高质量发展指数</span
            >
            <span
              class="span"
              :class="{ active: currentSlide == 2 }"
              @click="goTo(2)"
              >绿色发展指数</span
            >
          </div>
          <div class="index-content">
            <div class="map-container">
              <div id="mapContainer" style="height: 100%"></div>
            </div>
            <div class="carousel-container">
              <a-carousel
                style="height: 100%; overflow: hidden"
                :dots="false"
                ref="carousel"
                :after-change="onChange"
              >
                <div
                  class="table"
                  v-for="(item, key) in carouselList"
                  :key="key"
                >
                  <div class="tab-header">
                    <div class="rank">排名</div>
                    <div class="region">地区</div>
                    <div class="sort">指数排名</div>
                  </div>
                  <div
                    class="item"
                    v-for="(i, k) in item"
                    :key="k"
                    @click="setCity({ ...i, rank: k + 1 })"
                  >
                    <div
                      class="num"
                      :class="{ first: k == 0, second: k == 1, third: k == 2 }"
                    >
                      {{ k + 1 }}
                    </div>
                    <div class="city">{{ i.region_name_zh }}</div>
                    <div class="bar-box">
                      <div class="bar">
                        <div
                          class="inner-bar"
                          :style="{ width: `${i.percent}%` }"
                        ></div>
                      </div>
                    </div>
                    <div class="val">{{ i.val }}</div>
                  </div>
                </div>
              </a-carousel>
            </div>
          </div>
        </div>
        <div class="banners">
          <a-row :gutter="10">
            <a-col :span="6" @click="$router.push('/inputs_cube')">
              <img class="img" src="@/assets/banner3.png" alt="" />
              <p>内蒙古基层基础<br />数据中心</p>
            </a-col>
            <a-col :span="6" @click="$router.push('/datas_data')">
              <img class="img" src="@/assets/banner2.png" alt="" />
              <p>数据利用平台</p>
            </a-col>
            <a-col :span="6" @click="goDataIndex">
              <img class="img" src="@/assets/banner5.png" alt="" />
              <p>城市发展指数中心</p>
            </a-col>
            <a-col :span="6" @click="toDataV">
              <img class="img" src="@/assets/banner4.png" alt="" />
              <p>数据大屏</p>
            </a-col>
          </a-row>
        </div>
        <div class="screen">
          <div class="map fl" @click="toDataV">
            <img src="@/assets/map.png" alt="" />
          </div>
          <div class="info fl">
            <p class="title">内蒙古基层治理大数据平台</p>
            <span class="detail"
              >本平台通过门户网站、数据大屏、数据中心、指数中心等多个模块组成，全面反应内蒙古以及相关领域地区的发展现状，预测领域未来走势，发现当前存在的问题。系统平台通过内蒙古地区以及民族八省地区的宏观数据汇聚，构建形成内蒙古基层治理大数据平台；同时通过指数中心专业模型分析剖析内蒙古基层发展情况；专业的数据管理利用软件对数据进行科学的存储和高效的利用。最终本平台借助数据、软件技术以及行业积累，从多角度深入解析内蒙古地区各维度的发展情况。</span
            >
          </div>
        </div>
        <div class="end">
          <a-row :gutter="20">
            <a-col style="width: 560px" class="fl">
              <div class="head">
                <span class="name">政策措施</span>
                <span class="more fr" @click="$router.push('/newHome/measure')"
                  >更多 <img src="@/assets/fr.png"
                /></span>
              </div>
              <div class="column">
                <ul>
                  <li
                    v-for="item in measureList"
                    :key="item.newId"
                    @click="goMeasure(item)"
                  >
                    <span class="title">{{ item.newName }}</span>
                    <span class="name fr">{{ item.addTime }}</span>
                  </li>
                </ul>
              </div>
            </a-col>
            <a-col style="width: 640px" class="fr">
              <div class="head">
                <span class="name">电子期刊</span>
                <span class="more fr" @click="$router.push('/newHome/paper')"
                  >更多 <img src="@/assets/fr.png"
                /></span>
              </div>
              <div class="column">
                <ul>
                  <li
                    v-for="item in paperList"
                    :key="item.id"
                    @click="goPaperDetali(item)"
                  >
                    <span class="box">期刊</span>
                    <div class="title" style="width: 390px">
                      {{ item.title }}
                    </div>
                    <div class="name fr">
                      {{ item.pubtime.substring(0, 10) }}
                    </div>
                  </li>
                </ul>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
      <Login :visible="visible" @close="closeModal"></Login>
    </div>
  </div>
</template>

<script>
import { getCookie, messageTips } from "@/until/tools";
import Login from "@/components/Login_modal.vue";
import Footer from "@/components/newHomeFooter1.vue";
import AMapLoader from "@amap/amap-jsapi-loader";

// 高德地图安全密钥配置（必须在 AMapLoader.load 之前设置）
window._AMapSecurityConfig = {
  securityJsCode: "a6c95f2d49553768ccd84ab100783147",
};

export default {
  components: {
    Footer,
    Login
  },
  data() {
    return {
      visible: false,
      sid: getCookie("bd_sid") || "",
      realName: "",
      current: 0,
      newList: [],
      measureList: [],
      paperList: [],
      year: [],
      carouselList: [null, null, null, null],
      currentSlide: 3,
      timer: null,
      AMap: null,
      map: null,
      markers: [],
      districtVersion: 0, // 用于处理异步竞态问题
      updateMapTimer: null, // 防抖定时器
      districtSearch: null, // 行政区搜索实例
      polygons: [], // 保存当前的多边形
      polygonMap: {}, // 城市名 -> 多边形的映射
      boundaryCache: {}, // 缓存边界数据
      selectedCity: null, // 当前选中的城市
      isDrawing: false, // 是否正在绘制中
      isGoingTo: false, // 标记是否通过 goTo 触发的切换
      currentDrawingTask: null, // 当前绘制任务ID
      isCarouselLoading: false, // 轮播加载状态

    };
  },
  mounted() {
    this.getBannerList();
    this.getMeasureList();
    this.getMagazine();
    this.getYears();
    this.startAutoSwitch();
    this.getCarouselList(3);
    this.isCarousel();
    this.$nextTick(() => {
      this.initMap();
      // 确保轮播组件跳到正确位置
      if (this.$refs.carousel) {
        this.$refs.carousel.goTo(this.currentSlide);
      }
    });
    this.preloadCarouselData();

  },
  methods: {
    isCarousel() {
      const num = this.current % 2;
      this.$refs.carousel1.goTo(num);
    },
    closeModal() {
      this.visible = false;
    },
    goDataIndex() {
      if (this.sid||getCookie("bd_sid")) {
        this.$router.push("/newHome/dataIndex");
      } else {
        messageTips("请登录后访问", 2);
      }
    },
    goPaperDetali(item) {
      this.$router.push({
        path: "/newHome/paper/detail",
        query: { paperId: item.id },
      });
    },
    goMeasureDetail(item) {
      this.$router.push({
        path: "/newHome/measure/detail",
        query: { newId: item.newId },
      });
    },
    goNewDetail(item) {
      this.$router.push({
        path: "/newHome/news/detail",
        query: { newId: item.newId },
      });
    },
    toDataV() {
      window.open(
        "https://datav.aliyuncs.com/share/page/f060ee369b235b5b0aebf623bdd55ad2"
      );
    },
// 修改goTo和onChange方法
goTo(num) {
  this.currentSlide = num;
  // 立即更新轮播视图
  this.$refs.carousel.goTo(num);
  // 异步更新地图，不阻塞视图渲染
  setTimeout(() => {
    this.updateCarouselMap(num);
  }, 0);
},
onChange(current) {
  this.currentSlide = current;
  // 异步更新地图，不阻塞视图渲染
  setTimeout(() => {
    this.updateCarouselMap(current);
  }, 0);
},
// 新增地图更新方法
async updateCarouselMap(num) {
  this.isCarouselLoading = true;
try{
  if (this.map) {
    // 重置地图状态
    this.map.setZoom(5);
    this.map.setCenter([111.6554, 40.8184]);
    this.map.clearInfoWindow();
  }
  // 等待数据加载完成
  await this.getCarouselList(num);
  // 更新地图
  await this.debouncedUpdateMap(this.carouselList[num]);
}finally {
    this.isCarouselLoading = false;
  }
},
    getYears() {
      this.$http.getYears({ cubeId: 1 }).then((res) => {
        if (res.success) {
          this.year = res.list[0].years;
        }
      });
    },
    async preloadCarouselData() {
        // 优先加载当前展示的 slide
      if (!this.carouselList[this.currentSlide]) {
        await this.getCarouselList(this.currentSlide);
      }
      // 再加载其余
    for (let i = 0; i < 4; i++) {
      if (i !== this.currentSlide && !this.carouselList[i]) {
        await this.getCarouselList(i);
      }
    }
  },
  // 修改getCarouselList方法，去除num==0的强制刷新逻辑
  getCarouselList(num) {
    if (!this.carouselList[num]) {
      const params = {
        cubeId: num == 3 ? 91 : num + 1,
        years: this.year,
        indicatorCode: "01",
      };
      return this.$http.getIndicatorTop(params).then(async(res) => {
        if (res.success) {
          const list = res.list
            .map((item) => {
              item.percent = (item.val / res.list[0].val) * 100;
              return item;
            })
            .splice(0, 8);
          this.$set(this.carouselList, num, list);
        }
      });
    }
    return Promise.resolve();
  },
    // 防抖更新地图，避免快速切换时的竞态问题
    debouncedUpdateMap(data) {
      // 清除之前的定时器
      if (this.updateMapTimer) {
        clearTimeout(this.updateMapTimer);
      }
      // 立即增加版本号，使之前的异步操作失效
      this.districtVersion++;
      const currentVersion = this.districtVersion;
      // 延迟执行
      this.updateMapTimer = setTimeout(async () => {
        // 再次检查版本号，确保是最新的请求
        if (this.map && currentVersion === this.districtVersion) {
          await this.updateMap(data);
        }
      }, 200);
    },
    initMap() {
      AMapLoader.load({
        key: "e39037764d5c2ca2e2fc07a5c3505bc7",
        version: "2.0",
        plugins: [
          "AMap.DistrictLayer",
          "AMap.Marker",
          "AMap.InfoWindow",
          "AMap.DistrictSearch",
        ],
      })
      .then((AMap) => {
        this.AMap = AMap;
        this.map = new AMap.Map("mapContainer", {
          zoom: 5,
          center: [111.6554, 40.8184], // 内蒙古中心坐标
          resizeEnable: true,
        });
        // 初始化行政区搜索实例
        const opts = {
          subdistrict: 0,
          extensions: "all",
          showbiz: false,
          level: "city",
        };
        this.districtSearch = new this.AMap.DistrictSearch(opts);
        // 监听地图加载完成事件
        this.map.on("complete", () => {
          // 初始化时更新地图
          if (this.carouselList[this.currentSlide]) {
            this.updateMap(this.carouselList[this.currentSlide]);
          }
        });
      })
    },
    // 绘制市级多边形
    addPolygon(path, currentVersion, cityName) {
      if (!this.map) return;
      // 再次检查版本号
      if (currentVersion !== this.districtVersion) return;
      const self = this;
      const polygon = new this.AMap.Polygon({
        path: path,
        fillColor: "rgba(152,208,155,0.25)", // 区域填充颜色
        fillOpacity: 0.5,
        strokeOpacity: 1,
        strokeColor: "#3C8E77", // 边框颜色
        strokeWeight: 1,
      });
      // 保存城市名到多边形的扩展属性
      polygon.cityName = cityName;
      polygon.on("mouseover", () => {
        // 如果不是选中的城市，才改变透明度
        if (self.selectedCity !== cityName) {
          polygon.setOptions({
            fillOpacity: 0.7,
          });
        }
      });
      polygon.on("mouseout", () => {
        // 如果不是选中的城市，恢复默认透明度
        if (self.selectedCity !== cityName) {
          polygon.setOptions({
            fillOpacity: 0.5,
          });
        }
      });
      // 点击多边形也可以选中
      polygon.on("click", () => {
        self.highlightCity(cityName);
      });
      this.map.add(polygon);
      this.polygons.push(polygon);
      // 保存城市名和多边形的映射
      if (cityName) {
        this.polygonMap[cityName] = polygon;
      }
    },
    // 清除之前绑制的多边形和标记
    clearOverlays() {
      // 清除多边形
      if (this.polygons.length > 0) {
        this.map.remove(this.polygons);
        this.polygons = [];
      }
      // 清除标记
      if (this.markers.length > 0) {
        this.map.remove(this.markers);
        this.markers = [];
      }
      // 重置映射和选中状态
      this.polygonMap = {};
      this.selectedCity = null;
    },
    // 单个区域查询，返回 Promise，支持重试
    searchDistrict(searchKey, retryCount = 3) {
      return new Promise((resolve) => {
        // 尝试模糊匹配缓存
        const cachedKey = Object.keys(this.boundaryCache).find(key => 
          searchKey.includes(key) || key.includes(searchKey)
        );
        
        if (cachedKey) {
          resolve({ 
            key: searchKey, 
            boundary: this.boundaryCache[cachedKey], 
            success: true 
          });
          return;
        }
        const self = this;
        const doSearch = (remainingRetries) => {
          self.districtSearch.search(searchKey, (status, result) => {
            if (
              status === "complete" && result && result.districtList && result.districtList[0]
            ) {
              let boundary = result.districtList[0].boundaries;
              if (boundary) {
                for (let i = 0; i < boundary.length; i++) {
                  boundary[i] = [boundary[i]];
                }
                // 缓存边界数据
                self.boundaryCache[searchKey] = boundary;
                resolve({ key: searchKey, boundary: boundary, success: true });
              } else {
                resolve({ key: searchKey, boundary: null, success: false });
              }
            } else if (remainingRetries > 0) {
              // 请求失败，指数退避后重试
              setTimeout(() => {
                doSearch(remainingRetries - 1);
              }, 300 * Math.pow(2, retryCount - remainingRetries));
            } else {
              console.warn(`区域查询失败: ${searchKey}, status: ${status}`);
              resolve({ key: searchKey, boundary: null, success: false });
            }
          });
        };
        doSearch(retryCount);
      });
    },
    // 延迟函数，支持指数退避
    async delay(ms, attempt = 0) {
      // 指数退避：第n次重试等待时间 = 基础延迟 * 2^(n-1)
      const backoff = Math.min(300 * Math.pow(2, attempt), 3000);
      return new Promise(resolve => setTimeout(resolve, ms + backoff));
    },
    // 替换原来的 districtArea 方法，使用串行队列确保所有区域绘制成功
    async districtArea(data) {
  if (!this.map || !this.districtSearch || !Array.isArray(data)) {
    return;
  }
  const currentVersion = this.districtVersion;
  const taskId = Symbol('drawingTask');
  this.currentDrawingTask = taskId;
  const failedItems = [];
  
  // 定义单个区域处理函数
  const processItem = async (item, attempt = 0) => {
    // 双重版本检查，确保任务未被终止
    if (currentVersion !== this.districtVersion || this.currentDrawingTask !== taskId) {
      return false;
    }
    const searchKey = item.region_name_zh;
    if (!searchKey) return false;
    
    // 尝试模糊匹配缓存
    const cachedKey = Object.keys(this.boundaryCache).find(key => 
      searchKey.includes(key) || key.includes(searchKey)
    );
    
    if (cachedKey) {
      this.addPolygon(
        this.boundaryCache[cachedKey], currentVersion, searchKey
      );
      return true;
    }
    
    // 发起请求
    const result = await this.searchDistrict(searchKey, 3);
    // 再次检查版本号
    if (currentVersion !== this.districtVersion || this.currentDrawingTask !== taskId) {
      return false;
    }
    
    if (result.success && result.boundary) {
      this.addPolygon(result.boundary, currentVersion, searchKey);
      return true;
    } else {
      failedItems.push({ item, attempt });
      return false;
    }
  };
  
  // 第一轮：串行分批处理每个区域
  for (let i = 0; i < data.length; i += 2) {
    // 检查版本和任务ID
    if (currentVersion !== this.districtVersion || this.currentDrawingTask !== taskId) {
      return;
    }
    // 处理当前批次
    await Promise.all([
      processItem(data[i]),
      data[i+1] ? processItem(data[i+1]) : Promise.resolve()
    ]);
    // 让出主线程，避免阻塞UI
    await new Promise(resolve => requestIdleCallback(resolve));
    // 添加延迟，避免请求过于频繁
    await this.delay(50);
  }
  
  // 第二轮：对失败的项进行重试
  if (failedItems.length > 0 && currentVersion === this.districtVersion && this.currentDrawingTask === taskId) {
    await this.delay(500);
    for (let i = 0; i < failedItems.length; i++) {
      if (currentVersion !== this.districtVersion || this.currentDrawingTask !== taskId) {
        return;
      }
      const { item, attempt } = failedItems[i];
      const success = await processItem(item, attempt + 1);
      if (!success) {
        console.warn(`区域绘制失败: ${item.region_name_zh}`);
      }
      // 重试之间添加更长的延迟
      await this.delay(150, attempt);
    }
  }
},
    async updateMap(data) {
      if (!this.map || !Array.isArray(data)) return;
      // 清除之前的覆盖物
      this.clearOverlays();
      // 如果是边疆治理指数，显示全国地图
      if (this.currentSlide == 3) {
        this.map.setZoom(4);
        this.map.setCenter([104.195, 35.861]);
      }
      // 等待所有区域绘制完成
      await this.districtArea(data);
    },
    // 高亮指定城市的多边形
    highlightCity(cityName) {
      this.selectedCity = cityName;
      // 遍历所有多边形，设置样式
      this.polygons.forEach((polygon) => {
        if (polygon.cityName === cityName) {
          // 选中的城市：高亮显示
          polygon.setOptions({
            fillColor: "rgba(152,208,155,0.6)",
            fillOpacity: 1,
            strokeWeight: 2,
          });
          // 显示信息弹框
          const cityData = this.carouselList[this.currentSlide]?.find(
            (item) => item.region_name_zh === cityName
          );
          if (cityData) {
            // 计算城市中心位置
            const position = new this.AMap.LngLat(
              cityData.longitude, cityData.latitude
            );
            // 打开信息窗口
            const infoWindow = new this.AMap.InfoWindow({
              content: `<div style="padding: 10px; width: 180px; font-size: 14px;"><h3 style="font-size: 16px; margin: 0 0 8px 0;">${ cityData.region_name_zh }</h3><p style="margin: 4px 0;">排名: ${ this.carouselList[this.currentSlide].findIndex(
                (item) => item.region_name_zh === cityName
              ) + 1 }</p><p style="margin: 4px 0;">数值: ${cityData.val}</p></div>`,
              offset: new this.AMap.Pixel(0, -30),
            });
            infoWindow.open(this.map, position);
          }
        } else {
          // 其他城市：只显示边框，不填充
          polygon.setOptions({
            fillColor: "rgba(152,208,155,0.1)",
            fillOpacity: 0.2,
            strokeWeight: 1,
          });
        }
      });
    },
    // 重置所有多边形样式
    resetPolygonStyles() {
      this.selectedCity = null;
      this.polygons.forEach((polygon) => {
        polygon.setOptions({
          fillColor: "rgba(152,208,155,0.25)",
          fillOpacity: 0.5,
          strokeWeight: 1,
        });
      });
    },
    setCity(city) {
      // 缩放地图到指定城市
      if (this.map) {
        const position = new this.AMap.LngLat(city.longitude, city.latitude);
        // 打开信息窗口
        const infoWindow = new this.AMap.InfoWindow({
          content: `<div style="padding: 10px; width: 100px; font-size: 14px;"><h3 style="font-size: 16px; margin: 0 0 8px 0;">${city.region_name_zh}</h3><p style="margin: 4px 0;">排名: ${city.rank}</p><p style="margin: 4px 0;">数值: ${city.val}</p></div>`,
          offset: new this.AMap.Pixel(0, -30),
        });
        infoWindow.open(this.map, position);
        // 高亮选中的城市
        this.highlightCity(city.region_name_zh);
        // 根据当前指数类型设置不同的缩放级别
        // 边疆治理指数使用省级缩放级别，其他使用市级缩放级别
        const zoomLevel = this.currentSlide == 3 ? 5 : 6;
        this.map.setZoomAndCenter(zoomLevel, position);
      }
    },
    getBannerList(currentPage = 1) {
      const params = {
        currentPage: currentPage,
        type: 0,
      };
      this.$http.getNews(params).then((res) => {
        if (res.success) {
          this.newList = res.newList.splice(0, 8);
        }
      });
    },
    getMeasureList(currentPage = 1) {
      const params = {
        currentPage: currentPage,
        type: 3,
      };
      this.$http.getNews(params).then((res) => {
        if (res.success) {
          this.measureList = res.newList.splice(0, 5);
        }
      });
    },
    getMagazine() {
      this.$http.indexPaper().then((res) => {
        if (res.success) {
          this.paperList = res.paperList;
        }
      });
    },
    showImage(key) {
      this.current = key;
    },
    stopAutoSwitch() {
      //鼠标移入,清除定时器,
      clearInterval(this.timer);
    },
    startAutoSwitch() {
      //鼠标移出,启动定时器
      this.timer = setInterval(() => {
        this.isCarousel();
        if (this.current < this.newList.length - 1) {
          this.current++;
        } else {
          this.current = 0;
        }
      }, 6000);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/home/homeIndex1.scss";
</style>
